import { useImmer } from "use-immer";
import { useEffect } from "react";

const Component = ({ config, onChange }) => {
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  return (
    <>
      <table className="config-table">
        <thead>
        <tr>
          <th>Attribute</th>
          <th>Value</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Insufficient PIN effort score</td>
          <td>
            <input
              type="number"
              value={data.score}
              onChange={(e) =>
                updateData((d) => {
                  d.score = e.target.value;
                })
              }
            />
          </td>
        </tr>
        <tr>
          <td>
            History lookup min <small>[days]</small>
          </td>
          <td>
            <input
              type="number"
              value={data.historyLookupDaysMin}
              onChange={(e) =>
                updateData((d) => {
                  d.historyLookupDaysMin = e.target.value;
                })
              }
            />
          </td>
        </tr>
        <tr>
          <td>
            History lookup max <small>[days]</small>
          </td>
          <td>
            <input
              type="number"
              value={data.historyLookupDaysMax}
              onChange={(e) =>
                updateData((d) => {
                  d.historyLookupDaysMax = e.target.value;
                })
              }
            />
          </td>
        </tr>
        <tr>
          <td>
            Approve transaction lookup window <small>[minutes]</small>
          </td>
          <td>
            <input
              type="number"
              value={data.approvedTransactionLookupWindow}
              onChange={(e) =>
                updateData((d) => {
                  d.approvedTransactionLookupWindow = e.target.value;
                })
              }
            />
          </td>
        </tr>
        <tr>
          <td>
            Customer activity time frame <small>[minutes]</small>
          </td>
          <td>
            <input
              type="number"
              value={data.customerActivityTimeFrame}
              onChange={(e) =>
                updateData((d) => {
                  d.customerActivityTimeFrame = e.target.value;
                })
              }
            />
          </td>
        </tr>
        </tbody>
      </table>
    </>
  );
};

export default Component;
